module.exports = __webpack_public_path__ + "img/icon-close.cdaab387.svg";